import { MessageEvent } from '../constants/enums'
import { pubSubMessages, pubSubNotes } from '../state/pubSub'
import { AppRouter } from '../state/state.router'
import {
    clearHomePageSearchResults,
    search,
    updateSearchQuery,
} from '../state/state.search'
import { routerPush } from '../utilities/router'
import { notesSearch } from './notes'

export function headerSearch(query = '') {
    const visiblePage = AppRouter.route.visiblePage //router.asPath.toLowerCase()
    const isMessagesPage = visiblePage === 'messages'
    const isNotesPage = visiblePage === 'notes'
    const isHomePage = visiblePage === ''
    const trimmedQuery = query.trim()
    // minimum of 2 characters to search
    if (trimmedQuery.length === 1) return
    if (trimmedQuery.length === 0) {
        if (isMessagesPage) {
            pubSubMessages.emit(MessageEvent.SEARCH, null)
        }
        if (isNotesPage) {
            pubSubNotes.emit('search', null)
        }
        clearHomePageSearchResults()
        return
    }
    if (isMessagesPage) {
        pubSubMessages.emit(MessageEvent.SEARCH, trimmedQuery)
        return
    }
    if (isNotesPage) {
        void notesSearch(trimmedQuery)
        return
    }
    updateSearchQuery({
        search: trimmedQuery?.toLocaleLowerCase(),
        fromHomePage: isHomePage,
        type: null,
    })
    search()
    if (!isHomePage) {
        const path = `/search?query=${trimmedQuery}`
        routerPush(path)
    }
}
